import React, {useState } from 'react'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { useSnackbar } from 'notistack';
import { trackActivity } from '../../../../utils/mixpanel';
import { regexConstants } from '../../../../constants/regEx';
import { addInsuranceTypeApi, updateInsuranceTypeApi } from '../apiService';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';


const InsuranceTypeCRU = ({ addEditInsuranceType, modeType, getResponseBack, onToggleModal, params }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [insuranceType, setInsuranceType] = useState(addEditInsuranceType?.data);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const onAddEditInsuranceType = () => {
        let validationInputs = {};
        validationInputs = {
            name: insuranceType?.name?.trim() ? "" : "Please enter Name",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (insuranceType.id) {
                globalPutService(updateInsuranceTypeApi({ asset_slug: insuranceType?.slug }), insuranceType)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Insurance Type`, success_msg: response?.data?.message, item_id: insuranceType?.id, payload: insuranceType, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Insurance Type`, error_msg: response?.data?.message, item_id: insuranceType?.id, payload: insuranceType, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addInsuranceTypeApi({ leaseSlug: params?.leaseSlug, }), insuranceType).then((response) => {
                    if (checkApiStatus(response)) {
                        setLoading(false);
                        onToggleModal();
                        getResponseBack();
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Insurance Type`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: insuranceType, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Insurance Type`, error_msg: response?.data?.message, item_id: null, payload: insuranceType, response: response?.data })
                    }
                })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Insurance Type`, error_msg: validationInputs, })
        }
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Insurance Type`, page_type: page_type, })
    }
    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className="add-lease-dialog" maxWidth="md" fullWidth open={addEditInsuranceType?.modal} >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === "add" ? "Add" : modeType === "edit" ? "Edit" : "View"} Insurance Type
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                disabled={modeType === "view"}
                                id="name"
                                label="Name"
                                variant="outlined"
                                size="small"
                                required
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={insuranceType?.name || ""}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (regexConstants.restrictUnicodeCharacters.test(val.trimStart()) || val === "") {
                                        if (val.length <= 50) {
                                            setInsuranceType((prev) => ({ ...prev, name: val }));
                                            setError((prev) => ({ ...prev, name: "" }));
                                        }
                                    } else {
                                        e.preventDefault();
                                    }
                                }}
                                onFocus={()=>setError({...error,'name':""})}
                                onPaste={(e) => { const pasted = e.clipboardData.getData("text"); if (pasted.length > 50) { e.preventDefault(); } }}
                                error={Boolean(error.name)}
                                helperText={error.name || (insuranceType?.name?.length > 50 ? "Maximum 50 characters allowed" : "")}
                                fullWidth
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={insuranceType?.remarks || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    disabled={modeType === "view"}
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    value={insuranceType?.remarks || ""}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (regexConstants.restrictUnicodeCharacters.test(val) || val === "") {
                                            setInsuranceType((prev) => ({ ...prev, remarks: val.trimStart() }));
                                            setError((prev) => ({ ...prev, remarks: "" }));
                                        } else { e.preventDefault(); }
                                    }}
                                    error={!!error.remarks}
                                    helperText={error.remarks}
                                    fullWidth
                                    multiline
                                    rows={3}
                                />
                            </Grid>}
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant="contained" size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditInsuranceType() }}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                        </Button>}

                </DialogActions>
            </Dialog>
        </>
    )
}

export default InsuranceTypeCRU;